<div mat-dialog-content>
  <img id="generic-image" (click)="cmsMediaClick(genericPopupData?.contentStructureJson)"
    src="{{ genericPopupData?.contentStructureJson.mediaUrl }}" class="popup-img" (error)="onImageLoadError()" alt="" />
</div>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close]="false" id="btn-close" class="close-btn" (click)="closeDialog()">Close</button>
</div>